import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';
import { textractLineItemsTableLastColumnMatchedLinesSelector } from '@/domain/textract/selectors';
import { jeMatchedLinesSelector } from '@/domain/journal/selectors';
import { rtlEnable } from '@/domain/env';
import { ArcherElement } from 'react-archer';
import { MatchingColorsMap, TwoWayMatchAnchors, ArrowTargetFactory } from '@/components/TwoWayMatch/matching';

export const MatchingArrow = ({ headerLineNumber, row, hovered }) => {
  const jeMatchedLines = useSelector(jeMatchedLinesSelector);
  const textractMatchedLinesCells = useSelector(textractLineItemsTableLastColumnMatchedLinesSelector);
  const rtl = useSelector(rtlEnable);
  const line = row - headerLineNumber;
  const match = jeMatchedLines.get(String(line), new List());
  const targets = textractMatchedLinesCells[line] || [];

  // relations force arrow paint and must be set on hover only
  // <ArcherElement /> must be rendered anyway as lines can be rendered from pdf to line items
  // so that ArcherElement serves as target in this case
  const relations = targets
    .map((target, index) => {
      const matchType = match.get(index).get('status');
      // relation can not be empty as it doesnt force rerender
      // fake relations spam too much console noise
      // transparent coloring is approach from EY which is relatively meaningful
      const strokeColor = hovered === row ? MatchingColorsMap[matchType].border : 'transparent';

      return target ? ArrowTargetFactory(TwoWayMatchAnchors.rowElementId(target.id), strokeColor, rtl).toJS() : null;
    })
    .filter((x) => x);

  useEffect(() => {
    if (hovered === row) {
      const anchor = TwoWayMatchAnchors.rowMarkerElementId(targets[0]?.id);
      const el = document.getElementById(anchor);

      el?.scrollIntoView({ block: 'nearest' });
    }
  }, [hovered, row, targets]);

  // early return is not available due to UseEffect rule that prevents conditional useEffect invoсation
  if (!Object.keys(textractMatchedLinesCells).includes(String(line))) return null;

  return (
    <ArcherElement id={TwoWayMatchAnchors.jeLineElementId(line)} relations={relations}>
      <div id={TwoWayMatchAnchors.jeLineElementId(line)} />
    </ArcherElement>
  );
};

export default MatchingArrow;
